
  import axios from 'axios';
  import ImageViewer from './ImageViewer.vue';

  export default {
    components: { ImageViewer },
    props: {
      initialImages: { type: Array, default: () => [] },
      uploadUrl: { type: String, required: true },
      deleteUrl: { type: String, required: true },
      reorderUrl: { type: String, required: true },
      editable: { type: Boolean, default: false },
      emptyMessage: {type: String, default: 'Es sind keine Bilder hinterlegt.'},
      viewTitle: {type: String, default: ''}
    },
    data() {
      return {
        // last saved state, updated by server responses
        images: [...this.initialImages],
        mode: 'view',
        saving: false,
        error: null,
        // add mode
        selectedFiles: [],
        // delete mode
        markedIds: [],
        // reorder mode
        reorderingImages: [],
      };
    },
    computed: {
      showError: {
        get() {
          return this.error !== null;
        },
        set(value) {
          if (!value) this.error = null;
        },
      },
    },
    methods: {
      switchMode(mode) {
        // discard any unsaved working state when switching modes
        this.selectedFiles = [];
        this.markedIds = [];
        this.reorderingImages = [...this.images];
        this.error = null;
        if (this.$refs.fileInput) this.$refs.fileInput.value = '';
        this.mode = mode;
      },
      onFilesSelected(event) {
        this.selectedFiles = Array.from(event.target.files);
      },
      toggleMark(id) {
        const index = this.markedIds.indexOf(id);
        if (index === -1) {
          this.markedIds.push(id);
        } else {
          this.markedIds.splice(index, 1);
        }
      },
      async saveUpload() {
        const formData = new FormData();
        this.selectedFiles.forEach((file) => formData.append('imagesUpload[]', file));
        await this.submit(() => axios.post(this.uploadUrl, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        }));
      },
      async saveDelete() {
        await this.submit(() => axios.post(this.deleteUrl, { ids: this.markedIds }));
      },
      async saveReorder() {
        const orderedIds = this.reorderingImages.map((image) => image.id);
        await this.submit(() => axios.post(this.reorderUrl, { orderedIds }));
      },
      async submit(request) {
        this.saving = true;
        this.error = null;
        try {
          const response = await request();
          this.images = response.data.images;
          this.switchMode('view');
        } catch (err) {
          this.error = err.response?.data?.error
            ?? 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.';
        } finally {
          this.saving = false;
        }
      },
    },
  };
